<template>
  <div id="main" v-if="labels && attributes">
    <div class="label">{{ labels["first_attribute"][currentLanguage]}}</div>
    <v-expansion-panels class="attributeSelection" :accordion="true">
      <v-expansion-panel v-for="(group,i) in attributes" :key="i">
        <v-expansion-panel-header> {{ group.label[currentLanguage] }} </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="attribute"
            v-for="(attribute,j) in group.attributes"
            :key="i + '_' + j"
            :class="{ selected: attribute == selectedXAttribute }"
            @click="onXAttributeSelected(attribute)">

            {{ attribute.label[currentLanguage]}}

          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-checkbox
        v-model="comparing"
        :label="labels['compare'][currentLanguage]">
    </v-checkbox>

    <template v-if="comparing">
      <div class="label"> {{ labels["second_attribute"][currentLanguage]}} </div>
      <v-expansion-panels class="attributeSelection" :accordion="true">
        <v-expansion-panel v-for="(group,i) in attributes" :key="i">
          <v-expansion-panel-header> {{ group.label[currentLanguage] }} </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="attribute"
              v-for="(attribute,j) in group.attributes"
              :key="i + '_' + j"
              :class="{ selected: attribute == selectedYAttribute }"
              @click="onYAttributeSelected(attribute)">

              {{ attribute.label[currentLanguage]}}

            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </div>
</template>

<style scoped>
  #main {
    height: 100px;
    flex: 1 1 auto;
    padding: 15px;
    display: flex;
    flex-direction: column;
  }
  .label {
    font-size: 9pt;
  }
  .attributeSelection {
    margin-top: 5px;
    margin-bottom: 20px;
  }
  .attribute {
    padding: 2px;
    font-size: 11pt;
    user-select: none;
    cursor: pointer;
    color: #333333;
    margin-bottom: 5px;
    border-left: 2px solid #ffffff;
  }
  .attribute.selected {
    border-left: 2px solid #333333;
    /*padding: 4px;*/
  }
  .attribute:hover {
    background-color: #efefef;
  }
</style>

<script>
  export default {
    data: () => ({
      comparing: false
    }),
    computed: {
      attributes() {
        return this.$store.getters.attributes;
      },
      labels() {
        return this.$store.getters.labels;
      },
      currentLanguage() {
        return this.$store.getters.currentLanguage;
      },
      selectedXAttribute() {
        return this.$store.getters.selectedXAttribute;
      },
      selectedYAttribute() {
        return this.$store.getters.selectedYAttribute;
      }
    },
    methods: {
      onXAttributeSelected(attribute) {
        this.$store.commit("SET_SELECTED_X_ATTRIBUTE", attribute);
      },
      onYAttributeSelected(attribute) {
        this.$store.commit("SET_SELECTED_Y_ATTRIBUTE", attribute);
      }
    },
    watch: {
      comparing() {
        if (!this.comparing) {
          this.$store.commit("SET_SELECTED_Y_ATTRIBUTE", null);
        }
      }
    }
  }
</script>
